export interface SidebarSectionConfig {
  id: string;
  header: string;
  routeNames: string[];
}

export const SIDEBAR_SECTIONS: SidebarSectionConfig[] = [
  {
    id: "overview",
    header: "OVERVIEW",
    routeNames: ["Dashboard"],
  },
  {
    id: "operations",
    header: "OPERATIONS",
    routeNames: ["Onboarding", "Brands", "Devices", "Assign Platforms"],
  },
  {
    id: "access_control",
    header: "ACCESS CONTROL",
    routeNames: ["User Management"],
  },
  {
    id: "finance_billing",
    header: "FINANCE & BILLING",
    routeNames: ["Billing"],
  },
  {
    id: "system",
    header: "SYSTEM",
    routeNames: [
      "Master Table Data",
      "View Data History",
      "Authentication & Security",
      "Inquiry",
      "General Settings",
    ],
  },
];
